// extracted by mini-css-extract-plugin
module.exports = {"LowestPrice":"LowestPrice_LowestPrice__2PP2M","LowestPrice__Emphasis":"LowestPrice_LowestPrice__Emphasis__3o_kP"};